import { Container } from "react-bootstrap";
import { Helmet } from "react-helmet";
import Footer from "../Modules/Footer";
import NavigationBar from "../Modules/NavigationBar";

export default function PageDoesNotExist() {
	return (
		<>
		<NavigationBar/>
			<Container className="eo-page page-not-found">
				<Helmet>
					<title>{"EarsOnly | 404"}</title>
				</Helmet>

				<p className="eo-page__overline">404</p>
				<h1 className="eo-page__title">Page not found.</h1>
				<p className="eo-page__lead">The page you are looking for does not exist or has moved.</p>
				<a className="eo-button eo-button--accent" href="/home">Go to the homepage</a>
			</Container>
			<Footer />
		</>
	);
}
